import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
var AmdDropdownComponent = /** @class */ (function () {
    /**
     * @param {?} changeDetectorRef
     */
    function AmdDropdownComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this._isContentActive = false;
    }
    Object.defineProperty(AmdDropdownComponent.prototype, "isContentActive", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isContentActive;
        },
        /**
         * @param {?} isContentActive
         * @return {?}
         */
        set: function (isContentActive) {
            this._isContentActive = isContentActive;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AmdDropdownComponent.prototype.open = function () {
        this.isContentActive = true;
    };
    /**
     * @return {?}
     */
    AmdDropdownComponent.prototype.close = function () {
        this.isContentActive = false;
    };
    /**
     * @return {?}
     */
    AmdDropdownComponent.prototype.toggle = function () {
        this.isContentActive = !this.isContentActive;
    };
    /**
     * @return {?}
     */
    AmdDropdownComponent.prototype.onTriggerClicked = function () {
        this.toggle();
    };
    /**
     * @return {?}
     */
    AmdDropdownComponent.prototype.onOverlayClicked = function () {
        this.close();
    };
    AmdDropdownComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-dropdown',
                    template: "<amd-overlay [isActive]=\"isContentActive\" [isFixed]=\"true\" (onOverlayClicked)=\"onOverlayClicked()\"> </amd-overlay> <div class=\"amd-dropdown\"> <div class=\"amd-dropdown__trigger\" (click)=\"onTriggerClicked()\"> <ng-content select=\"[amdDropdownTrigger]\"></ng-content> </div> <div class=\"amd-dropdown__content\" *ngIf=\"isContentActive\"> <ng-content select=\"[amdDropdownContent]\"></ng-content> </div> </div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    exportAs: 'amdDropdown'
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdDropdownComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef, },
    ]; };
    return AmdDropdownComponent;
}());
export { AmdDropdownComponent };
function AmdDropdownComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdDropdownComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdDropdownComponent.ctorParameters;
    /** @type {?} */
    AmdDropdownComponent.prototype._isContentActive;
    /** @type {?} */
    AmdDropdownComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=dropdown.component.js.map
//# sourceMappingURL=dropdown.component.js.map
